import {
    ROOT,
    GET_ALL_DYNAMIC_RESTRICTION,
    DETAIL_DYNAMIC_RESTRICTION,
    UPDATE_DYNAMIC_RESTRICTION,
    CREATE_DYNAMIC_RESTRICTION,
    REMOVE_DYNAMIC_RESTRICTION,
    GET_PRODUCT_DYNAMIC_RESTRICTION,
    UPDATE_STATUS_DYNAMIC_RESTRICTION,
    SORT_DYNAMIC_RESTRICTION,
    DETAIL_SCHEDULE_DYNAMIC_RESTRICTION,
    UPDATE_SCHEDULE_DYNAMIC_RESTRICTION
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

function getAll(data) {
    return fetch(ROOT + GET_ALL_DYNAMIC_RESTRICTION, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function detailDynamic(data) {
    return fetch(ROOT + DETAIL_DYNAMIC_RESTRICTION + `/${data}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function updateDynamic(data) {
    return fetch(ROOT + UPDATE_DYNAMIC_RESTRICTION, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function createDynamic(data) {
    return fetch(ROOT + CREATE_DYNAMIC_RESTRICTION, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function removeDynamic(data) {
    return fetch(ROOT + REMOVE_DYNAMIC_RESTRICTION + `/${data}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getProduct() {
    return fetch(ROOT + GET_PRODUCT_DYNAMIC_RESTRICTION, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateStatus(data) {
    return fetch(ROOT + UPDATE_STATUS_DYNAMIC_RESTRICTION, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function sort(data) {
    return fetch(ROOT + SORT_DYNAMIC_RESTRICTION, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function detailSchedule() {
    return fetch(ROOT + DETAIL_SCHEDULE_DYNAMIC_RESTRICTION, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateScheduleDynamic(data) {
    return fetch(ROOT + UPDATE_SCHEDULE_DYNAMIC_RESTRICTION, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

//#endregion
export const dynamicService = {
    getAll,
    detailDynamic,
    updateDynamic,
    createDynamic,
    removeDynamic,
    getProduct,
    updateStatus,
    sort,
    detailSchedule,
    updateScheduleDynamic
};
